<template>
  <!-- 店铺信息 -->
  <div class="shopList">
    <div class="OrderPicking__left">
      <el-input v-model="filterText" placeholder="输入门店名称查询" class="wHP padding10"></el-input>
      <div class="flex1 scrollAuto scrollbar">
        <el-tree ref="tree" class="filter-tree" :data="storeList" :props="defaultProps" default-expand-all :filter-node-method="filterNode" @node-click="handleNodeClick"></el-tree>
      </div>
    </div>

    <div class="shopList__right box-shadow">
      <div class="fs16 fWB borderBottom paddingBottom10">校正记录</div>
      <el-row>
        <div style="float: right;margin-top: 10px;">
          <el-input v-model="queryParams.cName" clearable placeholder="关键字" class="marginLeft10 w250 input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
          </el-input>
        </div>
        <div style="margin-top: 10px">
          <el-button slot="append" @click="financeDialogVis = true">导出</el-button>
        </div>
      </el-row>
      <el-table row-key="code" :data="tableData">
        <el-table-column type="selection" align="center" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column label="序号" align="center" type="index" width="60" />
        <el-table-column align="center" label="门店编号" >
          <template slot-scope="scope">
            {{ formatStoreCode(scope.row.rstore) }}
          </template>
        </el-table-column>
        <el-table-column prop="sstore" align="center" label="门店名称" />
        <el-table-column prop="code" align="center" label="盘点单号" />
        <el-table-column prop="sku" align="center" label="货品SKU"/>
        <el-table-column prop="goodsName" align="center" label="货品名称"/>
        <el-table-column prop="surplus" align="center" label="账上库存"/>
        <el-table-column prop="actualSurplus" align="center" label="实际库存"/>
        <el-table-column prop="surplus" align="center" label="差额">
          <template slot-scope="scope">
            {{ scope.row.actualSurplus - scope.row.surplus }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" align="center" label="类型">
          <template slot-scope="scope">
            {{ scope.row.actualSurplus > scope.row.surplus ? '盘盈' : '盘亏' }}
          </template>
        </el-table-column>
        <el-table-column prop="creater" align="center" label="制单人"/>
        <el-table-column prop="create" align="center" label="制单时间"/>
        <el-table-column prop="saudit" align="center" label="审核人"/>
        <el-table-column prop="taudit" align="center" label="审核时间"/>
      </el-table>
      <div class="h50">
        <el-pagination :current-page="queryParams.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="queryParams.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { inventorySheet } from "@/api/shop/shop";
import baseUrls from "../../api/baseUrls";

export default {
  name: "ShopList",
  props: {},
  data() {
    return {
      tableData: [],
      storeList: [{ cname: "全部门店" }],
      filterText: '',
      queryParams: {
        currentPage: 10,
        pageSize: 1,
        total: 0
      },
      defaultProps: {
        children: "children",
        label: "cname",
      }
    };
  },
  created() {
    this.doSearch()
    this.selectStore()
  },
  methods: {
    formatStoreCode(storeId) {
      for (let i = 0; i < this.storeList.length; i++) {
        if (this.storeList[i].sid === storeId) {
          return this.storeList[i].finance
        }
      }
      return ''
    },
    handleNodeClick(node) {
      this.queryParams.currentPage = 1
      this.queryParams.pageSize = 10
      this.queryParams.total = 0
      this.queryPageList();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.cname.indexOf(value) !== -1;
    },
    resetQueryPara() {
      this.doSearch();
    },
    selectStore() {
      let url = `${this.baseUrls.orderStore}/queryList`;
      let params = {};
      this.topsAjax.get(url, params).then((res) => {
        this.storeList = this.storeList.concat(res);
      });
    },
    doSearch() {
      let params = this.queryParams;
      params.search = this.input;
      inventorySheet(params).then((res) => {
        this.queryParams.total = res.total;
        this.tableData = res.rows;
      });
    },
    // 分页
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryPageList();
    },
    handleCurrentChange(val) {
      this.queryParams.currentPage = val;
      this.queryPageList();
    },
  },
};
</script>

<style lang="scss" scoped>
.shopList {
  display: flex;
  flex-direction: row;
  height: 100%;
  flex: 1;
  overflow: hidden;

  &__left {
    width: 15%;
    background-color: white;
    margin: 3px;
    margin-right: 15px;
  }

  &__right {
    padding: 10px;
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 3px;
    background-color: white;
  }
}
</style>

<style lang="scss">
.el-tabs--left .el-tabs__item.is-left {
  text-align: left;
}

.el-tabs--left .el-tabs__header.is-left {
  width: 100%;
}

.father1 {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
</style>
